import React from "react";
import { Modal, Button } from "antd";
import FormLeaderAttribute from "../formLeaderAttribute/formLeaderAttribute";

const ModalLeaderAttribute = ({
    visible,
    onClose,
    states,
    setters,
    newLeaderAttribute,
    saveLeaderAttribute,
    onDeleteAllBehaviors,
}) => {
    return (
        <Modal
            title={newLeaderAttribute ? "Crear nuevo atributo del líder" : "Editar atributo del líder"}
            open={visible}
            onCancel={onClose}
            footer={null}
            width="80%"
            maskClosable={false}
        >
            <FormLeaderAttribute
                {...states}
                {...setters}
                newLeaderAttribute={newLeaderAttribute}
                saveLeaderAttribute={saveLeaderAttribute}
                onDeleteAllBehaviors={onDeleteAllBehaviors}
            />
        </Modal>
    );
};

export default ModalLeaderAttribute;
